import React from "react";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Typography from "material-ui/Typography";
import { withStyles } from "material-ui/styles";
import Icon from "material-ui/Icon";
import { ModalHeader, ModalContents, ModalFooter } from "../../common/modal";
import styles from "./styles";

const DeleteConfirmationModal = (props) => {
    const nodeToDelete = props.nodeToDelete;
    const isOpen = props.isOpen;
    const showHideConfirmationModal = props.showHideConfirmationModal;
    const classes = props.classes;
    const onConfirmationClose = props.onConfirmationClose;
    const translate = props.translate;

    const closeConfirmationModal = () => showHideConfirmationModal(false);
    
    function yes() {
        closeConfirmationModal();
        onConfirmationClose();
    }

    return (
        <Modal open={isOpen}>
            <div className={classes.root}>
                <Paper className={classes.modal}>
                    <ModalHeader>
                        <Typography type="subheading" color="inherit" className={classes.flex}>
                            {translate("deleteconfirmation")} "{nodeToDelete}"
                        </Typography>
                        <Button className={classes.button} onClick={closeConfirmationModal}>
                            <Icon>clear</Icon>
                        </Button>
                    </ModalHeader>
                    <ModalContents>
                        <Typography type="subheading" color="inherit">
                            {translate("del_records")}
                        </Typography>
                    </ModalContents>
                    <ModalFooter classes={classes}>
                      <Button className={classes.submit} raised color="accent" type="submit" onClick={yes}>
                          {translate("back_btn_yes")}
                      </Button>
            </ModalFooter>
                </Paper>
            </div>
        </Modal>
    );
};

export default withStyles(styles)(DeleteConfirmationModal);


// WEBPACK FOOTER //
// ./src/components/treeview/deleteConfirmationModal/index.js